import StyledBox from './styled/JoinOrganization/StyledBox';
import { useDispatch, useSelector } from 'react-redux';
import { joinOrganization } from '../../features/user/utils';
import { AppDispatch, RootState } from '../../store/store';
import { changeResetEmail } from '../../features/user/userSlice';
import { useNavigate } from 'react-router-dom';
import ResetEmail from './ResetEmail';
import { Typography } from '../new/Typography';
import { Button } from '../new/Button';

interface JoinOrganizationProps {
  organization: {
    name: string;
  };
}

const JoinOrganization: React.FC<JoinOrganizationProps> = ({
  organization,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const navigate = useNavigate();

  const resetEmailRequested = useSelector(
    (state: RootState) => state.user.resetEmailRequested,
  );

  const isRequestingToJoinOrg = useSelector(
    (state: RootState) => state.user.isRequestingToJoinOrg,
  );

  const isSendingVerificationCode = useSelector(
    (state: RootState) => state.user.isSendingVerificationCode,
  );

  const onRequestToJoinOrganization = async () => {
    try {
      let response = await dispatch(joinOrganization());

      const responseData = response.payload as { message: string };

      if (responseData.message === 'Request to join is sent') {
        navigate('/auth/pending');
      }
    } catch (error) {}
  };

  const resetEmail = () => {
    dispatch(changeResetEmail());
  };

  return (
    <StyledBox isLoading={isSendingVerificationCode}>
      {organization.name !== '' && !resetEmailRequested && (
        <>
          <Typography
            variant='h5'
            sx={{ fontSize: '1.875rem', marginTop: '1.25rem', width: '80%' }}
          >
            Join "{organization.name}"?
          </Typography>
          <Typography sx={{ width: '50%' }}>
            You are going to create an account as a part of "{organization.name}
            ".
          </Typography>
          <Button
            type='primary'
            sx={{
              width: '50%',
              textTransform: 'initial',
              marginBottom: '1.875rem',
              marginTop: '1.875rem',
              borderRadius: '0rem',
            }}
            disabled={isRequestingToJoinOrg}
            onClick={onRequestToJoinOrganization}
          >
            {isRequestingToJoinOrg ? 'Sending request to organization...' : 'Agree & Join'}
          </Button>
          <Button
            type='outline'
            sx={{
              width: '50%',
              textTransform: 'initial',
              borderRadius: '0rem',
            }}
            onClick={resetEmail}
          >
            Change Email
          </Button>
        </>
      )}
      {resetEmailRequested && <ResetEmail />}
    </StyledBox>
  );
};

export default JoinOrganization;
